export { default as WorksList } from './Works/WorksList';
export { default as VoiceList } from './Voice/VoiceList';
export { default as NewsList } from './News/NewsList';
export { default as Pagination } from './Pagination';
export { default as Get } from './Get';
export { SetDate } from './SetDate';
export { SetImg } from './SetImg';